module.exports = __webpack_public_path__ + "static/media/linear_equations.4d802a47.pdf";